// import leftPaneImage from '../assets/login_left-pane.webp';
import InputField from '../components/InputField'
import PinInput from '../components/PinInput'
import Button from '../components/Button'
import { Checkbox, States as CheckboxStates } from '../components/Checkbox'
import styles from './Login.module.scss'
import styles_DropdownMenu from '../components/DropdownMenu.module.scss'
import Link from '../components/Link'
import { runUpdateCheckpoint } from '../libs/pwaUpdate'
import usePrefStore from '../stores/prefs'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppWriteContext } from '../Contexts/AppWriteContext'
import DropdownMenu from '../components/DropdownMenu'
import useTranslation from '../Hooks/useTranslation'
import useHelpers from '../Hooks/useHelpers'
import { useDefaultLandingRoute } from '../Hooks/useHome'
// import useAppWrite from '../Hooks/useAppWrite';
// import { useLogger } from '../Contexts/Logger';
import glob_const from '../libs/glob_const'
import { checkPassword, isPasswordValid } from '../libs/passwordPolicy'
import type { PrefStoreState } from '../types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLoader, faWifi, faWifiExclamation, faArrowsRotate, faAngleLeft, faAngleRight, faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import { Progress } from '@mantine/core'
import { ToastContainer, toast } from 'react-toastify'
import { GlobalContext } from '../Contexts/GlobalContext'
import useSalesStore from '../stores/sales'
import useSales from '../Hooks/useSales'
import { purgeLocalData, PURGE_ALL } from '../libs/purgeLocalData'
import { db as dexie_db } from '../stores/db'
import Confirm from '../components/Confirm'
import { registerSW } from 'virtual:pwa-register'
// import bcrypt from 'bcryptjs'
import { hashSync } from 'bcrypt-ts'
import moment from 'moment'
import DatePicker, { registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import '../scss/datepicker.scss'

registerLocale('fr', fr)

const SHOW_DEBUG = 5 // Nb de click sur l'image' pour montrer la partie DEBUG
const SPINNER_DURATION = 3000

const menu_lang = {
   french: 'fr',
   english: 'en'
}

function Login(props) {
   // 3 façons de faire :
   // 1ère)
   // const [prefRememberMe, setPrefRememberMe] = usePrefStore((state) => ([state.prefRememberMe, state.setPrefRememberMe]))
   // 2ème)
   // const { prefRememberMe, setPrefRememberMe } = usePrefStore((state) => ({ prefRememberMe: state.prefRememberMe, setPrefRememberMe: state.setPrefRememberMe }))
   // 3ème)
   // const prefRememberMe = usePrefStore((state) => state.rememberMe)
   // const setPrefRememberMe = usePrefStore((state) => state.setRememberMe)

   // const prefRememberMe = usePrefStore((state) => state.rememberMe);
   // const setPrefRememberMe = usePrefStore((state) => state.setRememberMe);
   // const appWriteEndpoint = usePrefStore((state) => state.appWriteEndpoint);
   // const setAppWriteEndpoint = usePrefStore((state) => state.setAppWriteEndpoint);
   // const appWriteProjectId = usePrefStore((state) => state.appWriteProjectId);
   // const setAppWriteProjectId = usePrefStore((state) => state.setAppWriteProjectId);
   // const currentLang = usePrefStore((state) => state.currentLang);
   // const setCurrentLang = usePrefStore((state) => state.setCurrentLang);
   // const prefLogin = usePrefStore((state) => state.login);
   // const setPrefLogin = usePrefStore((state) => state.setLogin);
   // const setIsLogged = usePrefStore((state) => state.setIsLogged);

   const allPrefs = usePrefStore() // Pour l'envoi vers assistance IT si besoin
   const {
      initialState,
      rememberMe: prefRememberMe,
      setRememberMe: setPrefRememberMe,
      pwaApiEndpoint,
      setPwaApiEndpoint,
      currentLang,
      setCurrentLang,
      login: prefLogin,
      setLogin: setPrefLogin,
      setIsLogged,
      setHashedPassword,
      hashedPassword,
      setHashedLastLogin,
      hashedLastLogin,
      bcryptSalt,
      udid,
      recover,
      impersonateTarget,
      setImpersonation,
      appWriteEndpoint,
      setAppWriteEndpoint,
      setRecentCustomers,
      setRecentOrders,
      showCessDelay,
   } = allPrefs //usePrefStore()
   const { getVersion, getVersionDate, getCopyright, getDevRefShort, cleanCache } = useHelpers()
   //
   const defaultLandingRoute = useDefaultLandingRoute()
   const [login, setLogin] = useState<string>(prefRememberMe ? prefLogin : '')
   const [password, setPassword] = useState<string>('')
   // Impersonation (messika-pwa#10) : email saisi + avertissement avant purge (nb de commandes non synchronisées).
   const [impersonateExit, setImpersonateExit] = useState<boolean>(false)
   const [impersonateInput, setImpersonateInput] = useState<string>('')
   const [impersonateWarn, setImpersonateWarn] = useState<{ email: string, unsynced: number } | null>(null)
   const [isLostPasswordVisible, setIsLostPasswordVisible] = useState<boolean>(false)
   // Reset par PIN envoyé par mail (remplace l'OTP dans le bloc « Mot de passe oublié »).
   const [pin, setPin] = useState<string>('')
   const [pinSent, setPinSent] = useState<boolean>(false)
   const [resendCooldown, setResendCooldown] = useState<number>(0)   // secondes avant de pouvoir renvoyer (aligné throttle back 60s)
   const [isMenuLangVisible, setIsMenuLangVisible] = useState<boolean>(false)
   const [clickCount, setClickCount] = useState<number>(0) // A 5 on démasque le champ server
   const [sendingPrefs, setSendingPrefs] = useState<boolean>(false)
   const [importingPrefs, setImportingPrefs] = useState<boolean>(false)
   const [retrievedPrefs, setRetrievedPrefs] = useState<string | null>(null)
   const [isFetching, setIsFetching] = useState<boolean>(false)
   const [errorsFetching, setErrorsFetching] = useState<string | null>(null)
   const [fetchTotal, setFetchTotal] = useState<number>(0)
   const [fetchDone, setFetchDone] = useState<number>(0)
   const [fetchPourc, setFetchPourc] = useState<number>(0)
   const [fetchSubProgress, setFetchSubProgress] = useState<string | number>(0)
   const [syncFromDate, setSyncFromDate] = useState<string | null>(null)
   const [showSyncPicker, setShowSyncPicker] = useState<boolean>(false)
   const [canCleanDb, setCanCleanDb] = useState<boolean>(false)
   const [canCleanOrders, setCanCleanOrders] = useState<boolean>(false)
   const [canCleanCacheCollections, setCanCleanCacheCollections] = useState(false)
   const [canCleanCacheProducts, setCanCleanCacheProducts] = useState(false)
   const [showProgressBecauseTooLong, setShowProgressBecauseTooLong] = useState<boolean>(false)
   const [initState, setInitState] = useState<PrefStoreState | null>(null)
   //
   const { isWebSocketConnected } = { ...GlobalContext() } as any
   //
   const { last_updated_customers, last_updated_ventes_ral, last_updated_confies, last_updated_confies_ral, last_updated_bi_orders, last_updated_orders, setLastUpdatedBiOrders, setLastUpdatedConfies, setLastUpdatedConfiesRAL, setLastUpdatedOrders, setLastUpdatedCustomers, setLastUpdatedVentesRAL } = useSalesStore()
   //
   const { doLogin, doLogout, initialFetch, awPushWaitingOrders, awPushUdid, awEnsureUniqueUdidPrefix, fetchOtp, sendResetPin, resetPasswordPin, awConsumeForcedSync } = { ...AppWriteContext() } as any
   const { autoSelectSingleCustomer } = useSales()
   //
   const navigate = useNavigate()
   const passwordRef = useRef(null)
   // const { log } = useLogger();
   const { trans, transWithParams } = useTranslation()

   // console.log('ALL PREFS', initialState());

   // console.log('DO_LOGIN===', doLogin);
   // console.log('AW_CTXT===', AppWriteContext);

   // console.log(import.meta.env)  <== OK ça permet de récupérer les varenvs de prefixe = "VITE_" + qq autres de vite

   // Permet de refresh le SW (skip waiting) uniquement sur la page Login
   useEffect(() => {
      const updateSW = registerSW({
         onRegistered(r) {
            console.log('**SW++ 2 onRegistered', r)
            if (r) {
               r.update() // On check immédiatement à l'affichage du login
            }
         },
         onNeedRefresh() {
            console.log('**SW++ 2 onNeedRefresh')
            updateSW(true)
         }
      })
   }, [])

   const chooseLang = useCallback(
      (lang) => {
         setCurrentLang(lang)
         setIsMenuLangVisible(false)
      },
      [setCurrentLang]
   )

   useEffect(() => {
      setInitState(initialState())
   }, [initialState])

   // Date+heure de la dernière sync (la plus ancienne des last_updated_*)
   const lastSyncDate = useMemo(() => {
      const dates = [last_updated_customers, last_updated_ventes_ral, last_updated_confies, last_updated_confies_ral, last_updated_bi_orders, last_updated_orders]
         .filter(Boolean)
         .map(d => moment.utc(d))
         .filter(d => d.isValid())
      if (dates.length > 0) {
         return dates.reduce((min, d) => d.isBefore(min) ? d : min)
      }
      return null
   }, [last_updated_customers, last_updated_ventes_ral, last_updated_confies, last_updated_confies_ral, last_updated_bi_orders, last_updated_orders])

   useEffect(() => {
      setFetchPourc(fetchTotal > 0 ? (fetchDone * 100) / fetchTotal : 0)
   }, [fetchTotal, fetchDone])

   function onRememberMeHandler(status) {
      let newStatus = status === CheckboxStates.Checked
      setPrefRememberMe(newStatus)
      if (!newStatus) {
         setPrefLogin('')
      } else {
         setPrefLogin(login)
      }
      // return true; // Chnagement tjs OK
   }

   function onLoginChangeHandler(val) {
      val = val?.toLowerCase()
      setLogin(val)
      // if (prefRememberMe) {
      setPrefLogin(val)
      // } else {
      //    setPrefLogin('');
      // }
   }

   function onPasswordChangeHandler(val) {
      setPassword(val)
   }

   const startFetches = useCallback(
      (newLogin, forcedSyncDate = null) => {
         setFetchDone(0)
         setErrorsFetching(null)
         setShowProgressBecauseTooLong(false)

         // Date de re-sync effective : forçage serveur (prefs.forced_last_sync, prioritaire),
         // sinon date choisie manuellement dans l'UI. On écrase alors les last_updated_*.
         const effectiveSyncDate = forcedSyncDate ?? syncFromDate
         if (effectiveSyncDate && !newLogin) {
            const syncMoment = moment.utc(effectiveSyncDate).startOf('day')
            const setters = [
               { current: last_updated_customers, setter: setLastUpdatedCustomers },
               { current: last_updated_ventes_ral, setter: setLastUpdatedVentesRAL },
               { current: last_updated_confies, setter: setLastUpdatedConfies },
               { current: last_updated_confies_ral, setter: setLastUpdatedConfiesRAL },
               { current: last_updated_bi_orders, setter: setLastUpdatedBiOrders },
               { current: last_updated_orders, setter: setLastUpdatedOrders },
            ]
            for (const { current, setter } of setters) {
               if (!current || syncMoment.isBefore(moment.utc(current))) {
                  setter(syncMoment.toISOString())
               }
            }
            // Le forçage serveur a effectivement écrasé les last_updated_* → on le consomme
            // (supprime la pref forced_last_sync côté serveur) pour qu'il ne se ré-applique pas
            // au prochain login. Consommé ICI, lié à l'écrasement, et non au succès du fetch.
            if (forcedSyncDate) awConsumeForcedSync()
         }

         console.log('Start fetching')
         initialFetch(
            newLogin,
            async () => {
               console.log('Fetching finished')
               console.log('setIsLogged(true)')
               setIsLogged(true)
               // messika-pwa#34 : la bascule de canal / de version attend la fin de l'envoi des commandes en attente
               try { await awPushWaitingOrders() } catch (e) { console.warn('awPushWaitingOrders KO', e) }
               // Si la base locale ne contient qu'un seul vrai customer, on l'auto-sélectionne
               // et on télécharge silencieusement son tarif si absent.
               autoSelectSingleCustomer()
               navigate('/catalog', { replace: true })
               void runUpdateCheckpoint()
            },
            (err) => {
               console.log('Error fetching')
               console.log('setIsLogged(false)')
               setIsLogged(false)
               setErrorsFetching(err)
               setTimeout(() => {
                  // On réactive le bouton un peu plus tard, le temps d'attirer le regard sur l'erreur et éviter des envois trop rapides
                  setIsFetching(false)
               }, 2000)
            },
            setFetchTotal,
            () => {
               setFetchDone((cur) => cur + 1)
            },
            (txt) => {
               setFetchSubProgress(txt)
            }
         )

         setTimeout(() => {
            // On n'affiche la barre de chargement que si c'est trop long (> 2sec). Ca evite une barre trop furtive
            setShowProgressBecauseTooLong(true)
         }, 500)
      },
      [initialFetch, navigate, setIsLogged, awPushWaitingOrders, autoSelectSingleCustomer, syncFromDate, awConsumeForcedSync, last_updated_customers, last_updated_ventes_ral, last_updated_confies, last_updated_confies_ral, last_updated_bi_orders, last_updated_orders, setLastUpdatedCustomers, setLastUpdatedVentesRAL, setLastUpdatedConfies, setLastUpdatedConfiesRAL, setLastUpdatedBiOrders, setLastUpdatedOrders]
   )

   // console.log('PREFS', usePrefStore());
   // console.log('Remain', remainFetching, totalFetching, (totalFetching - remainFetching) * 100);
   // console.log(errorsFetching);

   const cleanDb = useCallback(
      async (force: boolean = false) => {
         setClickCount(0)
         await purgeLocalData({
            db: canCleanDb || force,
            orders: canCleanOrders,
            cacheCollections: canCleanCacheCollections,
            cacheProducts: canCleanCacheProducts
         })
         if (canCleanDb || force) setCanCleanDb(false)
         if (canCleanOrders) setCanCleanOrders(false)
         if (canCleanCacheCollections) setCanCleanCacheCollections(false)
         if (canCleanCacheProducts) setCanCleanCacheProducts(false)
      },
      [canCleanCacheCollections, canCleanCacheProducts, canCleanDb, canCleanOrders]
   )

   const askImpersonation = useCallback(async () => {
      const email = impersonateInput.trim().toLowerCase()
      if (!email) return
      const unsynced = await dexie_db.orders.where('status').equals('locked4sync').count()
      setImpersonateWarn({ email, unsynced })
   }, [impersonateInput])

   // Quitter une impersonation en attente depuis l'écran de login (#16) : purge totale, cible oubliée.
   const confirmExitImpersonation = useCallback(async () => {
      setImpersonateExit(false)
      await purgeLocalData(PURGE_ALL)
      setImpersonation(null, null)
   }, [setImpersonation])

   const confirmImpersonation = useCallback(async () => {
      if (!impersonateWarn) return
      const email = impersonateWarn.email
      setImpersonateWarn(null)
      await purgeLocalData(PURGE_ALL)       // purge d'abord (resetPrefs conserve l'impersonation), mémorisation ensuite
      setImpersonation(email, null)
      setImpersonateInput('')
      setClickCount(0)
   }, [impersonateWarn, setImpersonation])

   const onLogin = useCallback(async () => {
      if (!isFetching) {
         try {
            setIsFetching(true) // Pour désactiver le bouton, car on va fetcher très prochainement
            // console.log(password, bcryptSalt);
            // const hash = bcrypt.hashSync(password, bcryptSalt)
            // const hash_login = bcrypt.hashSync(login, bcryptSalt)
            const hash = hashSync(password, bcryptSalt)
            const hash_login = hashSync(login, bcryptSalt)
            console.log('hash', hash)
            const ret = await doLogin(login, password)
            console.log(ret)
            if (!ret.status && ret.data?.impersonationRefused) {
               // Impersonation refusée (droit absent / email inconnu) : en-tête retiré, session supprimée, cible oubliée.
               setIsFetching(false)
               setIsLogged(false)
               setHashedPassword(null)
               const refusal = ret.data?.refusal
               const msg = refusal?.cause === 'noRight' ? transWithParams('?impersonation_refused_no_right', ret.data?.login ?? login)
                  : refusal?.cause === 'unexpected' ? transWithParams('?impersonation_refused_unexpected', refusal.email)
                  : refusal?.cause === 'error' ? transWithParams('?impersonation_refused_error', refusal.message)
                  : trans('?impersonation_refused')
               toast.error(msg, { position: 'top-right', autoClose: 6000, theme: 'colored' })
            } else if (ret.status) {
               // Vérifié online, ok, loggué. On passe ensuite à l'étape de fetch des data
               // Login/Pwd ok
               console.log('Vérification en online réussie. Loggué')
               // setIsLogged(true)
               setHashedPassword(hash)
               const same_login = hash_login === hashedLastLogin
               console.log('HASH LOGIN', hash_login, hashedLastLogin)
               if (!same_login) {
                  // Ca signifie qu'on a changé d'utilisateur. On purge la base des clients et des commande
                  console.log('HASH LOGIN>>>', hash_login, hashedLastLogin)
                  setRecentCustomers(null)
                  setRecentOrders(null)
                  await cleanDb(true)
                  setHashedLastLogin(hash_login)
               }
               // Garantir un préfixe d'udid unique (vs autres devices) AVANT d'enregistrer l'udid
               // et avant toute création de commande. Online garanti ici (login vérifié serveur).
               await awEnsureUniqueUdidPrefix()
               awPushUdid(login)
               // OTP (2FA) désactivée pour le moment (glob_const.otp_enabled). En chargeant le doc OTP
               // on ferait apparaître l'entrée menu OTP ; on skippe donc tant que la 2FA est off.
               if (glob_const.otp_enabled) fetchOtp()
               console.log('Start fetches')
               startFetches(!same_login, ret.forcedLastSync ?? null) // isLoggued(true) dans cette fonction ; ret.forcedLastSync = forçage re-sync serveur (prefs), appliqué + consommé lors de l'écrasement des last_updated_*
            } else {
               // Pas vérifié online, 2 possibilités : pas de réseau ou refusé par le serveur
               console.log(JSON.stringify(ret.data))
               if (ret.data.code === glob_const.http_codes.UNAUTHORIZED) {
                  // Refusé, on ne peut plus se connecter (même en offline) tant qu'on n'aura pas réussi une nv connexion online
                  console.log('Vérification en online refusée par le serveur. Pas/plus loggué')
                  await doLogout()
                  console.log('setIsLogged(false)')
                  setIsLogged(false)
                  setIsFetching(false)
                  setHashedPassword(null)
                  // setPassword('')
                  toast.error(trans('?Accès refusé'), {
                     position: 'top-right',
                     autoClose: 2500,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     theme: 'colored'
                  })
               } else if (ret.data.code === glob_const.http_codes.BAD_REQUEST) {
                  // Autre erreur, on affiche le message mais on ne peut plus se connecter (même en offline) tant qu'on n'aura pas réussi une nv connexion online
                  console.log('Pb de vérification en online par le serveur (ex : mdp top court). Pas/plus loggué')
                  console.log('setIsLogged(false)')
                  setIsLogged(false)
                  setIsFetching(false)
                  setHashedPassword(null)
                  toast.error(ret.data.message ?? trans('?Erreur inconnue'), {
                     position: 'top-right',
                     autoClose: 2500,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     theme: 'colored'
                  })
               } else {
                  // Erreur mais pas refusé par serveur. Certainement un pb réseau. On vérifie le hash du mdp de la dernière conexion online réussie
                  // console.log('Compare', password, hashedPassword)
                  // const isPasswordValid = bcrypt.compareSync(password, hashedPassword)
                  const isPasswordValid = hashedPassword === hashSync(password, bcryptSalt)
                  console.log('Ret', JSON.stringify(isPasswordValid))
                  if (isPasswordValid && impersonateTarget) {
                     // Impersonation en attente : invérifiable sans serveur (#16).
                     toast.error(trans('?impersonate_offline_refused'), { position: 'top-right', autoClose: 4000, theme: 'colored' })
                     setHashedPassword(null)
                  } else if (isPasswordValid) {
                     console.log('Vérification en online impossible, mais mdp vérifié offline. Loggué')
                     console.log('setIsLogged(true)')
                     setIsLogged(true)
                     navigate('/catalog', { replace: true })
                  } else {
                     // setIsFetching(false)
                     console.log('Vérification en online impossible, et mdp impossible à vérifier offline. Pas/plus loggué')
                     toast.error(ret.data.message ?? trans('?Erreur inconnue'), {
                        position: 'top-right',
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: 'colored'
                     })
                     setHashedPassword(null)
                  }
                  setIsFetching(false)
               }
            }
         } catch (err) {
            console.log('Pb inattendu au login. Pas/plus loggué', err)
            toast.error(trans('?Erreur inconnue'), {
               position: 'top-right',
               autoClose: 2500,
               hideProgressBar: false,
               closeOnClick: true,
               pauseOnHover: true,
               draggable: true,
               theme: 'colored'
            })
            setIsLogged(false)
            setIsFetching(false)
         }
      }
   }, [
      awPushUdid,
      awEnsureUniqueUdidPrefix,
      bcryptSalt,
      cleanDb,
      doLogin,
      doLogout,
      fetchOtp,
      hashedLastLogin,
      hashedPassword,
      impersonateTarget,
      isFetching,
      login,
      navigate,
      password,
      setHashedLastLogin,
      setHashedPassword,
      setIsLogged,
      setRecentCustomers,
      setRecentOrders,
      startFetches,
      trans,
      transWithParams
   ])

   // Tout est prêt pour du login avec des services OAuth2 tiers. Exemple fonctionnel pour Amazon
   // function onLoginWithAmazon() {
   //    doLoginWithAmazon()
   // }

   // COMMENTÉ POUR TEST V0.52 MESSIKA - A REMETTRE QUAND OK APPWRITE !
   // useEffect(() => {
   //    setIsLogged(false)   // On part du principe qu'on a un fake "success"
   //    if (props.status === 'success') {
   //       getAccount().then((res) => {
   //          console.log('ICI!')
   //          if (res) {
   //             setIsLogged(true)
   //             navigate("/", { replace: true })
   //          } else {
   //             console.log('Fake login!')
   //          }
   //       }).catch(err => {
   //          console.log('Fake login!', err)
   //       })
   //    }
   // }, [getAccount, navigate, props.status, setIsLogged])

   // console.log(setRememberMe)
   // console.log('rm', remember_me)
   // console.log("login", login)
   // console.log('login', props);

   const sendPrefs = useCallback(() => {
      setSendingPrefs(true)
      axios
         .post(
            `${pwaApiEndpoint}/device_prefs`,
            {
               udid,
               prefs: allPrefs
            }
         )
         .then((data) => {
            console.log('DATA', data)
         })
         .catch((err) => {
            console.log('ERR', err)
         })
         .finally(() => {
            // On laisse 1sec pour avoir le temps de lire
            setTimeout(() => {
               setClickCount(0) // On raffiche la page de login
               setSendingPrefs(false)
            }, SPINNER_DURATION)
         })
   }, [allPrefs, pwaApiEndpoint, udid])

   const doRetrievePrefs = useCallback(() => {
      axios
         .get(`${pwaApiEndpoint}/device_prefs/${udid}`)
         .then((data) => {
            console.log('DATA', data)
            setRetrievedPrefs(data.data)
         })
         .catch((err) => {
            setRetrievedPrefs(null)
         })
   }, [pwaApiEndpoint, udid])

   const importPrefs = useCallback(() => {
      setImportingPrefs(true)
      setTimeout(() => {
         setClickCount(0) // On raffiche la page de login
         setImportingPrefs(false)
         console.log(retrievedPrefs)
         try {
            recover(JSON.parse(retrievedPrefs))
            // On close le sendback
            axios.patch(
               `${pwaApiEndpoint}/device_prefs/${udid}`,
               {}
            )
            navigate(defaultLandingRoute, { replace: true })
         } catch (err) {
            console.log('Erreur de recover', err)
         }
      }, SPINNER_DURATION)
   }, [defaultLandingRoute, navigate, pwaApiEndpoint, recover, retrievedPrefs, udid])

   useEffect(() => {
      console.log('RETR...')
      if (!retrievedPrefs && clickCount >= SHOW_DEBUG) {
         console.log('RETR...ICI')
         doRetrievePrefs()
      } else if (retrievedPrefs && clickCount < SHOW_DEBUG) {
         setRetrievedPrefs(null)
      }
   }, [clickCount, doRetrievePrefs, retrievedPrefs])

   function onKeyDown(evt) {
      // console.log(evt.key, evt.target, passwordRef, passwordRef.current);
      if (evt.key === 'Enter') {
         evt.preventDefault()
         if (evt.target.name === 'login') {
            passwordRef.current?.focus()
         } else {
            onLogin()
         }
      }
   }

   // function refresh() {
   //    console.log('**SW++ ICI');
   //    const reg = registerSW({
   //       // onRegistered(r) {
   //       //    console.log('**SW++ onRegistered', r);
   //       //    r && setInterval(() => {
   //       //       console.log('**SW++ update?');
   //       //       r.update()
   //       //    }, intervalMS)
   //       // },
   //       // onNeedRefresh() {
   //       //    console.log('**SW++ onNeedRefresh');
   //       //    console.log('**SW++ onNeedRefresh updateSW !!!');
   //       //    // updateSW()
   //       //    setNeedRefresh(true)
   //       // },
   //       // onOfflineReady() {
   //       //    console.log('**SW++ onOfflineReady');
   //       // },
   //    })
   //    console.log('**SW++ REG', reg);
   //    reg()
   // }

   // console.log(sendingPrefs);

   // Compte à rebours du lien « Renvoyer » (aligné sur le throttle backend de 60s).
   useEffect(() => {
      if (resendCooldown <= 0) return
      const id = setTimeout(() => setResendCooldown((c) => (c > 0 ? c - 1 : 0)), 1000)
      return () => clearTimeout(id)
   }, [resendCooldown])

   function lostPassword() {
      // On bascule entre login et reset : le champ mot de passe change de sens
      // (mot de passe ↔ nouveau mot de passe) → on le vide dans les deux sens.
      setPassword('')
      setIsLostPasswordVisible((val) => {
         const next = !val
         if (!next) {
            // On referme le bloc : on réinitialise l'état PIN.
            setPin('')
            setPinSent(false)
            setResendCooldown(0)
         }
         return next
      })
   }

   // Envoi (ou renvoi) du PIN par mail à l'adresse associée à l'identifiant saisi.
   // Réponse volontairement générique (anti-énumération : on ne dit pas si le compte existe).
   async function sendPin() {
      if (!login) {
         toast.error(trans('?Saisissez votre identifiant'), { position: 'top-right', autoClose: 2500, theme: 'colored' })
         return
      }
      await sendResetPin(login)
      setPinSent(true)
      setResendCooldown(60)
      toast.success(trans('?pin_sent'), { position: 'top-right', autoClose: 4000, theme: 'colored' })
   }

   async function onChangePassword() {
      if (!isPasswordValid(password)) {
         toast.error(trans('?pwd_too_weak'), { position: 'top-right', autoClose: 3500, theme: 'colored' })
         return
      }
      const ret = await resetPasswordPin(login, pin, password)
      if (ret) {
         toast.success(trans('?resetpwd_ok'), {
            position: 'top-right',
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            // progress: ,
            theme: 'colored'
         })
         setIsLostPasswordVisible(false)
         setPin('')
         setPinSent(false)
         setPassword('')   // on revient au login par défaut : vider le champ mot de passe (c'était le nouveau mdp)
      } else {
         toast.error(trans('?resetpwd_nok'), {
            position: 'top-right',
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: 'colored'
         })
      }
   }

   const purgeCacheAndLogin = () => {
      cleanCache()
      if (!isFetching) {
         onLogin()
      }
   }

   return (
      <div className={styles.login} onKeyDown={(evt) => onKeyDown(evt)}>
         {impersonateExit && (
            <Confirm
               title={trans('?impersonate_exit')}
               destructive
               okLabel={trans('?Continuer')}
               onCancel={() => setImpersonateExit(false)}
               onOK={confirmExitImpersonation}
            >
               <p>{trans('?impersonate_exit_warn')}<br />{trans('?impersonate_exit_warn_2')}</p>
            </Confirm>
         )}
         {impersonateWarn && (
            <Confirm
               title={trans('?impersonate_warn_title')}
               destructive
               okLabel={trans('?Continuer')}
               onCancel={() => setImpersonateWarn(null)}
               onOK={confirmImpersonation}
            >
               <div>
                  <p>
                     {trans('?impersonate_warn_purge')}<br />
                     {trans('?impersonate_warn_as')}{" "}
                     <b>{impersonateWarn.email}</b>
                  </p>
                  <p><b>{trans('?impersonate_warn_return')}</b></p>
                  {impersonateWarn.unsynced > 0 && <p>{transWithParams('?impersonate_warn_unsynced', impersonateWarn.unsynced)}</p>}
               </div>
            </Confirm>
         )}
         <div className={styles.left}>
            {/* <img src={leftPaneImage} alt="Messika modèle" onClick={() => setClickCount(click => click + 1)} /> */}
            <img src="/assets/login_left-pane.webp" alt="Messika modèle" onClick={() => setClickCount((click) => click + 1)} />
         </div>
         <div className={styles.right}>
            <div className={styles.top}>
               <FontAwesomeIcon icon={isWebSocketConnected ? faWifi : faWifiExclamation} className={isWebSocketConnected ? styles.green : styles.red} />
            </div>
            <div className={styles.lang}>
               <Button
                  onClick={() => {
                     setIsMenuLangVisible((val) => !val)
                  }}
               >
                  {currentLang === 'en' ? 'EN' : 'FR'}
               </Button>
               {isMenuLangVisible && (
                  <DropdownMenu noscrollbars left={-100} top={-20} onSelect={chooseLang}>
                     <li className={`${currentLang !== menu_lang.english ? styles_DropdownMenu.selected : ''}`} id={menu_lang.french}>
                        {trans('?Français', 1, { lng: 'fr' })}
                     </li>
                     <li className={`${currentLang === menu_lang.english ? styles_DropdownMenu.selected : ''}`} id={menu_lang.english}>
                        {trans('?Anglais', 1, { lng: 'en' })}
                     </li>
                  </DropdownMenu>
               )}
            </div>
            {clickCount >= SHOW_DEBUG && (
               <div className={styles.assist_view}>
                  <h1>{trans("?Page d'assistance")}</h1>
                  <div className={styles.assist_inline}>
                     <span>{trans('?assist_wrong')}</span>
                     <Button
                        onClick={() => {
                           setClickCount(0)
                        }}
                     >
                        {trans('?Quitter cette page')}
                     </Button>
                  </div>
                  <div className={styles.assist_block}>
                     <span>{trans('?clean_db')}</span>
                     <div className={styles.clean_db}>
                        <Checkbox caption={trans('?Base de données')} checked={canCleanDb ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={() => setCanCleanDb((val) => !val)} />
                        <Checkbox caption={trans('?Commandes (Danger !)')} checked={canCleanOrders ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={() => setCanCleanOrders((val) => !val)} />
                        <Checkbox caption={trans('?Images clés')} checked={canCleanCacheCollections ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={() => setCanCleanCacheCollections((val) => !val)} />
                        <Checkbox caption={trans('?Images modèles')} checked={canCleanCacheProducts ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={() => setCanCleanCacheProducts((val) => !val)} />
                     </div>
                     <Button onClick={() => cleanDb()} disabled={!canCleanDb && !canCleanOrders && !canCleanCacheCollections && !canCleanCacheProducts}>
                        {trans('?Vider')}
                     </Button>
                  </div>
                  {lastSyncDate && (
                     <div className={styles.sync_info}>
                        {!showSyncPicker && (
                           <div className={styles.sync_row}>
                              <span className={styles.sync_label}>{syncFromDate ? trans("?Forcer sync à partir de") : trans("?Dernière sync")}</span>
                              <span className={`${styles.sync_field} ${syncFromDate ? styles.sync_field_forced : ''}`} onClick={() => { if (!isFetching) { setShowSyncPicker(true) } }}>
                                 {syncFromDate ?? lastSyncDate.local().format('YYYY-MM-DD @ HH:mm')}
                                 {syncFromDate && (
                                    <span className={styles.sync_clear} onClick={(e) => { e.stopPropagation(); setSyncFromDate(null) }}>
                                       <FontAwesomeIcon icon={faXmark} />
                                    </span>
                                 )}
                              </span>
                           </div>
                        )}
                        {showSyncPicker && (
                           <div className={styles.sync_row}>
                              <span className={styles.sync_label}>{trans("?Forcer sync à partir de")}</span>
                              <div className={`${styles.sync_picker_wrap} ${syncFromDate ? styles.sync_picker_forced : ''}`}>
                                 <DatePicker
                                    selected={syncFromDate ? moment(syncFromDate).toDate() : lastSyncDate.toDate()}
                                    locale={currentLang === 'fr' ? 'fr' : 'en-US'}
                                    calendarStartDay={1}
                                    dateFormat="yyyy-MM-dd"
                                    maxDate={moment().subtract(1, 'day').toDate()}
                                    dayClassName={(date) => {
                                       const now = new Date()
                                       if (date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) {
                                          return styles.sync_today
                                       }
                                       return null
                                    }}
                                    onChange={() => {}}
                                    onSelect={(date) => { if (date) { setSyncFromDate(moment(date).format('YYYY-MM-DD')); setShowSyncPicker(false) } }}
                                    disabled={isFetching}
                                    open={true}
                                    onClickOutside={() => { setShowSyncPicker(false) }}
                                    renderCustomHeader={({ date, changeYear, decreaseMonth, increaseMonth, decreaseYear, increaseYear, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                       const now = new Date()
                                       const nextYearDate = new Date(date.getFullYear() + 1, date.getMonth(), 1)
                                       const isNextYearFuture = nextYearDate > now
                                       const handleIncreaseYear = () => { increaseYear() }
                                       return (
                                          <div className={styles.sync_cal_header}>
                                             <div className={styles.sync_cal_year}>
                                                <button onClick={decreaseYear} type="button"><FontAwesomeIcon icon={faAngleLeft} /></button>
                                                <span>{date.getFullYear()}</span>
                                                <button onClick={handleIncreaseYear} disabled={isNextYearFuture} type="button"><FontAwesomeIcon icon={faAngleRight} /></button>
                                             </div>
                                             <div className={styles.sync_cal_month}>
                                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button"><FontAwesomeIcon icon={faAngleLeft} /></button>
                                                <span>{date.toLocaleString(currentLang === 'fr' ? 'fr-FR' : 'en-US', { month: 'long' })}</span>
                                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button"><FontAwesomeIcon icon={faAngleRight} /></button>
                                             </div>
                                          </div>
                                       )
                                    }}
                                 />
                              </div>
                           </div>
                        )}
                     </div>
                  )}
                  <div className={styles.assist_block}>
                     <div className={styles.serv_reload}>
                        <InputField
                           title={`${trans('?Serveur')} "DB"`}
                           placeholder="domaine.com"
                           name="server"
                           value={appWriteEndpoint}
                           onChange={(val) => setAppWriteEndpoint(val?.toLowerCase())}
                           button={
                              <Button
                                 onClick={() => {
                                    setAppWriteEndpoint(initState?.appWriteEndpoint)
                                 }}
                              >
                                 <FontAwesomeIcon icon={faArrowsRotate} />
                              </Button>
                           }
                        />
                     </div>
                     <div className={styles.serv_reload}>
                        <InputField
                           title={`${trans('?Serveur')} "ADM"`}
                           placeholder="domaine.com"
                           name="server"
                           value={pwaApiEndpoint}
                           onChange={(val) => setPwaApiEndpoint(val?.toLowerCase())}
                           button={
                              <Button
                                 onClick={() => {
                                    setPwaApiEndpoint(initState?.pwaApiEndpoint)
                                 }}
                              >
                                 <FontAwesomeIcon icon={faArrowsRotate} />
                              </Button>
                           }
                        />
                     </div>
                     <Button green onClick={() => { setClickCount(0) }}>
                        {trans('?Valider')}
                     </Button>
                  </div>
                  <div className={styles.assist_inline}>
                     {!retrievedPrefs && (
                        <>
                           <span>{trans('?assist_send_prefs')}</span>
                           {!sendingPrefs && <Button onClick={sendPrefs}>{trans('?Envoyer')}</Button>}
                           {sendingPrefs && (
                              <Button inactive>
                                 <FontAwesomeIcon icon={faLoader} className={styles.rotate} />
                                 {trans('?Envoi en cours')}
                              </Button>
                           )}
                        </>
                     )}
                     {retrievedPrefs && (
                        <>
                           <span>{trans('?assist_got_prefs')}</span>
                           {!importingPrefs && (
                              <Button green onClick={importPrefs}>
                                 {trans('?Importer')}
                              </Button>
                           )}
                           {importingPrefs && (
                              <Button green inactive>
                                 <FontAwesomeIcon icon={faLoader} className={styles.rotate} />
                                 {trans('?Importer')}
                              </Button>
                           )}
                        </>
                     )}
                  </div>
                  <div className={styles.assist_block}>
                     <div className={styles.serv_reload}>
                        <InputField
                           title={trans('?impersonate_as')}
                           placeholder="exemple@domaine.com"
                           name="impersonate"
                           value={impersonateInput}
                           onChange={(val) => setImpersonateInput(val ?? '')}
                           button={<Button onClick={askImpersonation} disabled={!impersonateInput.trim()}><FontAwesomeIcon icon={faCheck} /></Button>}
                        />
                     </div>
                  </div>
               </div>
            )}
            {clickCount < SHOW_DEBUG && (
               <>
                  <h1>{trans('?Veuillez vous identifier')}</h1>
                  {/* preventDefault : le bouton « Envoyer le code » est dans le form ; sans ça, le clic
                      soumet le formulaire → rechargement de page et perte de la saisie du PIN.
                      La connexion par Enter reste gérée par onKeyDown (div parent). */}
                  <form onSubmit={(e) => e.preventDefault()}>
                     {impersonateTarget && <div style={{ margin: '0 0 0.6rem', fontWeight: 600, lineHeight: 1.5 }}>{trans('?impersonate_banner_login')} <span style={{ color: 'var(--color-primary-red, #c00)' }}>{impersonateTarget}</span><br />{trans('?impersonate_banner_login_2a')} <strong style={{ fontWeight: 800, textDecoration: 'underline', margin: '0 0.25em' }}>{trans('?impersonate_banner_login_2b')}</strong> {trans('?impersonate_banner_login_2c')} <strong style={{ fontWeight: 800, textDecoration: 'underline', margin: '0 0.25em' }}>{trans('?impersonate_banner_login_2d')}</strong> {trans('?impersonate_banner_login_2e')}</div>}
                     {impersonateTarget && <div style={{ margin: '0 0 0.6rem' }}><Button small disabled={isFetching} onClick={() => setImpersonateExit(true)}>{trans('?impersonate_exit')}</Button></div>}
                     <InputField title={trans('?Identifiant')} placeholder="exemple@domaine.com" name="login" value={login} onChange={onLoginChangeHandler} disabled={isFetching} />
                     <InputField title={isLostPasswordVisible ? trans('?Nouveau mot de passe') : trans('?Mot de passe')} placeholder={isLostPasswordVisible ? trans('?Votre nouveau mot de passe') : trans('?Votre mot de passe')} password name="password" value={password} ref={passwordRef} onChange={onPasswordChangeHandler} disabled={isFetching} />
                     {isLostPasswordVisible && (() => {
                        const c = checkPassword(password)
                        const rules: Array<[boolean, string]> = [
                           [c.minLength, trans('?pwd_rule_length')],
                           [c.lower, trans('?pwd_rule_lower')],
                           [c.upper, trans('?pwd_rule_upper')],
                           [c.digit, trans('?pwd_rule_digit')],
                           [c.symbol, trans('?pwd_rule_symbol')],
                        ]
                        return (
                           <ul style={{ listStyle: 'none', padding: 0, margin: '0.35rem 0 0.6rem', fontSize: '0.8rem' }}>
                              {rules.map(([okRule, label], i) => (
                                 <li key={i} className={okRule ? styles.green : styles.red} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                    <FontAwesomeIcon icon={okRule ? faCheck : faXmark} />
                                    <span>{label}</span>
                                 </li>
                              ))}
                           </ul>
                        )
                     })()}
                     {isLostPasswordVisible && (
                        <>
                           <div style={{ margin: '0.35rem 0 0.85rem' }}>
                              <Button small onClick={sendPin} disabled={isFetching || !login || resendCooldown > 0}>
                                 {(pinSent ? trans('?Renvoyer') : trans('?Envoyer le code')) + (resendCooldown > 0 ? ` (${resendCooldown})` : '')}
                              </Button>
                           </div>
                           {pinSent && (
                              <p style={{ margin: '0 0 0.85rem', fontSize: '0.9rem', color: 'var(--color-black, #1a1a1a)' }}>
                                 {trans('?check_mailbox_for_pin')}
                              </p>
                           )}
                           <PinInput title={trans('?Code reçu par email')} value={pin} onChange={setPin} disabled={isFetching} />
                        </>
                     )}
                     {/* <table>
                        <tr>
                           <td>{bcrypt.hashSync(login, bcryptSalt)}</td>
                        </tr>
                        <tr>
                           <td>{hashedLastLogin}</td>
                        </tr>
                     </table> */}
                  </form>
                  <div className={styles.toolz}>
                     <Checkbox caption={trans('?Se souvenir de moi')} checked={`${prefRememberMe ? CheckboxStates.Checked : CheckboxStates.Unchecked}`} onChange={onRememberMeHandler} />
                     {!isLostPasswordVisible && (
                        <Link disabled={isFetching} onClick={lostPassword}>
                           {trans('?Mot de passe oublié')}
                        </Link>
                     )}
                     {isLostPasswordVisible && (
                        <Link disabled={isFetching} onClick={lostPassword}>
                           {trans('?Masquer')}
                        </Link>
                     )}
                  </div>
                  {!isLostPasswordVisible && (
                     <Button big onClick={onLogin} onLongPress={purgeCacheAndLogin} longPressDuration={showCessDelay} disabled={isFetching}>
                        {trans("?S'identifier")}
                     </Button>
                  )}
                  {isLostPasswordVisible && (
                     <Button big onClick={onChangePassword} disabled={isFetching || !isPasswordValid(password) || pin.length < 6}>
                        {trans('?Changer le mot de passe')}
                     </Button>
                  )}
               </>
            )}
            {isFetching && showProgressBecauseTooLong && (
               <>
                  <Progress
                     color="red"
                     styles={{ bar: { backgroundColor: 'var(--color-menu-text-accent)' } }}
                     radius="xl"
                     size="xl"
                     value={fetchPourc}
                     animate={true}
                     className={styles.progress}
                  />
                  {fetchSubProgress}
               </>
            )}
            {errorsFetching && (
               <>
                  <span className={styles.fetch_error}>{errorsFetching}</span>
               </>
            )}
            <div className={styles.bottom}>
               <span>
                  UDID : {udid.substring(0, 4)}...{udid.slice(-4)}
               </span>
               <span>
                  {getVersion()} - {getCopyright()} - {getVersionDate()}
               </span>
               <span>{getDevRefShort()}</span>
            </div>
         </div>
         <ToastContainer />
      </div>
   )
}

export default Login
